export class Endoso {
    //polizaId
    polizaId: string = "l66xHtlkmi56Uqz3MEYuqw==";
    //negocio
    negocio: string = "";
    //tipo de endoso(1-Cancelacion,2-Placa,3-No.Serie,4-No.Motor)
    tipoEndoso: number = 0;
    //aseguradoraId
    aseguradoraId: number = 0;
    //extension
    endoso: EndosoValue = new EndosoValue();
    /**Bandera coche seguro */
    cocSeg: number = 1;
}

export class EndosoValue {
    //value
    value: string = "";
}